import './App.css';
import AppRoutes from './router/Routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AIAgent from './components/common/AIAgent';
import { useLocation } from 'react-router-dom';
import DepartmentBanner from "./components/common/DepartmentBanner";
import { BannerProvider, useBanner } from './context/BannerContext';
import { HeaderFooterProvider } from './context/HeaderFooterContext';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';

function AppContent() {
  const location = useLocation();
  const { showBanner } = useBanner();
  
  // Function to parse current URL path
  const parseUrlPath = (path) => {
    const parts = path.split('/').filter(part => part);
    const urlInfo = {
      type: 'default',
      division: null,
      department: null
    };

    if (parts[0] === 'Division' && parts[1]) {
      urlInfo.type = 'division';
      urlInfo.division = parts[1];
      
      if (parts[2] === 'Department' && parts[3]) {
        urlInfo.type = 'department';
        urlInfo.department = parts[3];
      }
    }

    return urlInfo;
  };

  

  const urlInfo = parseUrlPath(location.pathname);

  return (
    <div className="app-container">
      <>
        <Header />
        {showBanner && urlInfo.type === 'department' && <DepartmentBanner />}
        <AIAgent/>

        <main>
          <AppRoutes />
        </main>

        <Footer />
      </>
      <ToastContainer />
    </div>
  );
}

function App() {
  return (
    <HeaderFooterProvider>
      <BannerProvider>
        <AppContent />
      </BannerProvider>
    </HeaderFooterProvider>
  );
}

export default App;
